import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useIntl } from 'react-intl';
import messages from '../readinessMessages';
// The rows in order stay folded away: only the attention points need action.
const OkRowsToggle = ({ count, colSpan, isOpen, onToggle }) => {
    const intl = useIntl();
    if (count === 0)
        return null;
    return (_jsx("tr", Object.assign({ className: "readiness-toggle-row", onClick: onToggle }, { children: _jsxs("td", Object.assign({ colSpan: colSpan }, { children: [_jsx("i", { className: `fa fa-fw ${isOpen ? 'fa-caret-down' : 'fa-caret-right'}` }), intl.formatMessage(messages.OkCount, { count }), " \u2014", ' ', _jsx("a", Object.assign({ role: "button", tabIndex: 0 }, { children: intl.formatMessage(isOpen ? messages.Hide : messages.Show) }))] })) })));
};
export default OkRowsToggle;
